import React, { Component } from 'react';

class AgeInputLimitModal extends Component {
  _onChangeAge = () => {
    const { onAngeInputChange, editDetail } = this.props;
    if (editDetail) {
      onAngeInputChange();
    }
  }

  render() {
    return (
      <div
        className="modal fade theme-modal" id="ageInputLimit"
        tabIndex="-1" aria-labelledby="invalidAgeInputModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-sm">
          <div className="modal-content">
            <div className="modal-body">
              <p>Age must be in between 1 and 120.</p>
            </div>
            <div className="modal-footer">
              <div className="row gx-2">
                <div className="col-12">
                  <button type="button" className="btn btn-gray w-100" onClick={this._onChangeAge}>OK</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default AgeInputLimitModal;
